import { render, staticRenderFns } from "./CardBuyMultiTrip.vue?vue&type=template&id=6241d7f2&scoped=true&"
import script from "./CardBuyMultiTrip.vue?vue&type=script&lang=js&"
export * from "./CardBuyMultiTrip.vue?vue&type=script&lang=js&"
import style0 from "./CardBuyMultiTrip.vue?vue&type=style&index=0&id=6241d7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241d7f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
